import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TextInput } from "components/common/FormControls";
import { Button } from "@material-ui/core";

const FormStep2 = ({ styles, handleFormChange, data, setStepNo, formData }) => {
    const [petData, setPetData] = useState(data);
    const [fieldError, setFieldError] = useState({});
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);

    const checkFormInvalid = () => {
        const copyFormData = { ...petData };

        return Object.values(copyFormData).some((v) => v === null || `${v}`.trim() === "");
    };

    const validateGetQuoteForm = () => {
        const isFormDataInvalid = !checkFormInvalid();

        return isFormDataInvalid;
    };

    const handleOnChange = (e, value) => {
        setPetData({
            ...petData,
            [value.name]: value.value,
        });

        const copyFieldError = { ...fieldError };

        delete copyFieldError[value.name];

        setFieldError(copyFieldError);
    };

    const handleOnBlur = (e) => {
        const targetName = e.target.id;
        const value = e.target.value;

        const copyFieldError = { ...fieldError };

        if (value?.trim() === "") {
            copyFieldError[targetName] = true;
        } else {
            delete copyFieldError[targetName];
        }

        setFieldError(copyFieldError);
    };

    const handleSubmit = () => {
        handleFormChange(petData);
        setStepNo(3);
    };

    useEffect(() => {
        const getValidators = () => [validateGetQuoteForm];

        const validators = getValidators();

        const isDisabled = validators.some((validator) => validator.call());

        setIsBtnDisabled(!isDisabled);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [petData]);

    const heading1 = `Nice to meet you ${formData?.firstName?.trim()}!`;
    const heading2 = "What’s your <b>pet’s name</b>?";

    return (
        <>
            <div className="conversationalForm__container__formContainer__petData">
                <div className="conversationalForm__container__formContainer__petData__heading">
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__desktop"
                        dangerouslySetInnerHTML={{
                            __html: heading1,
                        }}
                    />
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__desktop"
                        dangerouslySetInnerHTML={{
                            __html: heading2,
                        }}
                    />
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__mobile"
                        dangerouslySetInnerHTML={{
                            __html: `${heading1} ${heading2}`,
                        }}
                    />
                </div>
                <div className="conversationalForm__container__formContainer__petData__inputDiv">
                    <div className="conversationalForm__container__formContainer__petData__inputDiv__fieldGroup">
                        <TextInput
                            name="petName"
                            value={petData.petName}
                            onChange={handleOnChange}
                            identifier="petName"
                            type="text"
                            inputVariant="filled"
                            inputLabel={"Pet's name"}
                            onBlur={handleOnBlur}
                            error={fieldError["petName"] ? "Please enter your pet's name." : false}
                        />
                    </div>
                </div>
                <div className="conversationalForm__container__formContainer__petData__button">
                    <Button
                        type="button"
                        size="large"
                        onClick={handleSubmit}
                        fullWidth
                        variant="contained"
                        disabled={isBtnDisabled}
                        id="submit"
                        className={"submit-button"}
                        style={isBtnDisabled ? { ...styles?.button?.disable } : { ...styles?.button?.active }}
                    >
                        Next
                    </Button>
                </div>
            </div>
        </>
    );
};

FormStep2.propTypes = {
    styles: PropTypes.object,
    handleFormChange: PropTypes.func,
    data: PropTypes.object,
    setStepNo: PropTypes.func,
    formData: PropTypes.object,
};

export default FormStep2;
